import { css } from "@microsoft/fast-element";
import { display } from "@fluentui/web-components";
import { borderRadiusCircular, borderRadiusMedium, colorBrandBackground2, colorBrandForeground1, colorNeutralBackground3, colorNeutralBackground1, colorNeutralBackgroundDisabled, colorNeutralForeground2, colorNeutralForegroundDisabled, colorNeutralStroke1, spacingHorizontalNone, spacingHorizontalXXS, spacingHorizontalXS, spacingHorizontalS, spacingHorizontalSNudge, spacingVerticalXXL, spacingVerticalXXS, spacingVerticalXS, strokeWidthThin, typographyCaption1Styles, typographyCaption2Styles, typographyBody1Styles } from "@fluentui/web-components";
import { sizeHorizontalL, sizeHorizontalM, sizeVerticalL, sizeVerticalM, sizeVerticalXL, sizeVerticalXXL, sizeVerticalXXXL } from "@fabric-msft/theme";
export const styles = css `
  ${display("block")}
  .caption1 {
    ${typographyCaption1Styles}
  }
  .caption2 {
    ${typographyCaption2Styles}
  }
  .body1 {
    ${typographyBody1Styles}
  }

  :host {
    height: ${sizeVerticalXXXL};
    width: fit-content;
    display: inline-flex;
    align-items: center;
    background-color: ${colorNeutralBackground3};
    color: ${colorNeutralForeground2};
    border-radius: ${borderRadiusMedium};
    border: none;
  }

  :host([size="extraSmall"]) {
    height: ${sizeVerticalXL};
  }

  :host([size="small"]) {
    height: ${sizeVerticalXXL};
  }

  :host([shape="circular"]) {
    border-radius: ${borderRadiusCircular};
  }

  :host([appearance="outline"]) {
    border: ${strokeWidthThin} solid ${colorNeutralStroke1};
    background-color: unset;
  }

  :host([appearance="brand"]) {
    background-color: ${colorBrandBackground2};
    color: ${colorBrandForeground1};
  }

  :host([appearance="brand"]) fluent-button.dismissButton {
    color: ${colorBrandForeground1};
  }

  :host([disabled]) {
    color: ${colorNeutralForegroundDisabled};
  }

  :host([disabled]) ::slotted(*) {
    color: ${colorNeutralForegroundDisabled};
  }

  fluent-button.dismissButton {
    min-width: unset;
    padding: ${spacingHorizontalNone};
    min-height: unset;
    margin-inline-start: ${spacingHorizontalNone};
    margin-inline-end: ${spacingHorizontalSNudge};
  }

  :host([disabled]) fluent-button.dismissButton {
    color: ${colorNeutralForegroundDisabled};
  }
  :host([size="extraSmall"]) fluent-button.dismissButton {
    width: ${sizeHorizontalM};
  }

  :host([size="extraSmall"]) fluent-button.dismissButton svg {
    height: ${sizeVerticalM};
  }

  :host([size="small"]) fluent-button.dismissButton {
    width: ${sizeHorizontalL};
  }

  :host([size="small"]) fluent-button.dismissButton svg {
    height: ${sizeVerticalL};
  }

  .container {
    display: flex;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .textContent {
    display: flex;
    flex-direction: column;
    padding: 0 ${spacingHorizontalXXS};
    padding-bottom: ${spacingVerticalXXS};
    margin: ${spacingVerticalXXS} ${spacingHorizontalS};
  }

  :host(.hasLeadingIcon) .textContent {
    margin-inline-start: ${spacingHorizontalXS};
  }

  :host([dismissButton]) .textContent {
    margin-inline-end: ${spacingHorizontalXS};
  }

  ::slotted([slot="leadingIcon"]) {
    margin-inline-end: ${spacingHorizontalNone};
    margin-inline-start: ${spacingHorizontalS};
    display: flex;
    align-items: center;
  }

  :host([size="small"]) ::slotted([slot="leadingIcon"]),
  :host([size="extraSmall"]) ::slotted([slot="leadingIcon"]) {
    margin-inline-start: ${spacingHorizontalSNudge};
  }

  ::slotted([slot="image"]) {
    margin: ${spacingHorizontalXXS};
    margin-inline-end: ${spacingHorizontalNone};
    display: flex;
    align-items: center;
    height: calc(${spacingVerticalXXL} + ${spacingVerticalXS});
  }

  :host([size="small"]) ::slotted([slot="image"]) {
    height: ${sizeVerticalXL};
  }

  :host([size="extraSmall"]) ::slotted([slot="image"]) {
    height: ${sizeVerticalL};
  }

  :host([appearance="brand"]) ::slotted([slot="image"]) {
    background-color: ${colorBrandForeground1};
    color: ${colorNeutralBackground1};
  }

  :host([disabled][appearance="brand"]) ::slotted([slot="image"]) {
    background-color: ${colorNeutralForegroundDisabled};
    color: ${colorNeutralBackgroundDisabled};
  }
`;
//# sourceMappingURL=tag.styles.js.map